








































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon, IconConfig } from '../sw-icon';
import { CSSStyleOptions } from '../common-types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-icon-button';

@Component({
  components: {
    SwIcon,
  },
})
export default class SwIconButton extends SwExtendedVue {
  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  @Prop({ type: [Object, String], required: true })
  icon: IconConfig | string | 'divider';

  @Prop({ type: [String, Number], default: 29 })
  buttonSize: string | number;

  @Prop({ type: String })
  color: string | undefined;

  @Prop({ type: Boolean, default: false })
  selected: boolean;

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  noBorder: boolean;

  cssPrefix = cssPrefix;

  isHover: boolean = false;

  get effectiveIconConfig(): IconConfig {
    let useConfig: IconConfig | null = null;

    if (this.isDivider) {
      useConfig = { name: 'diamond', size: 6 };
    } else if (typeof this.icon === 'string') {
      useConfig = { name: this.icon };
    } else {
      useConfig = Object.assign({}, this.icon);
    }

    if (this.disabled || this.selected) {
      delete useConfig.color;
    }

    return Object.assign(
      {
        size: 16,
      },
      useConfig,
    );
  }

  get isDivider(): boolean {
    return this.icon === 'divider';
  }

  get specifiedButtonSizeNumeric() : number  {
    if (typeof this.buttonSize === 'number') {
      return this.buttonSize;
    }
    return utilService.sizeMap[this.buttonSize] || utilService.sizeMap['mlarge'];
  }

  get specifiedIconSizeNumeric(): number {
    const iconSize = this.effectiveIconConfig.size;
    if (typeof iconSize === 'number') {
      return iconSize;
    }
    return iconSize ? utilService.sizeMap[iconSize] : utilService.sizeMap['medium'];
  }

  private getEffectiveButtonStyle(): CSSStyleOptions {
    const style: CSSStyleOptions = {};
    const specifiedButtonSize = this.specifiedButtonSizeNumeric;
    const iconSize = this.specifiedIconSizeNumeric;
    const proportion = iconSize / specifiedButtonSize;
    const maxProportion = 20 / 29;

    const minWidth = iconSize / maxProportion;
    const padding = Math.max((minWidth - iconSize) / 2, 10);

    if (proportion > maxProportion) {
      style.minWidth = `${minWidth}px`;
      style.height = `${minWidth}px`;
    } else {
      style.minWidth = `${specifiedButtonSize}px`;
      style.height = `${specifiedButtonSize}px`;
    }
    if (this.hasLabel()) {
      style.paddingLeft = `${padding}px`;
      style.paddingRight = `${padding}px`;
    }
    if (this.color && !this.disabled && !this.selected) {
      style.color = this.isHover ? undefined : this.color;
    }
    return style;
  }

  private hasLabel() {
    const labelSlot = utilService.getVueScopedSlot(this.$scopedSlots);
    return !!labelSlot && labelSlot.length > 0;
  }

  private onMouseEnter() {
    this.isHover = true;
  }
  private onMouseLeave() {
    this.isHover = false;
  }

  private onClick(event: MouseEvent) {
    if (this.disabled) {
      event.stopImmediatePropagation();
    }
  }
}
